import * as yup from "yup";

export const medicationValidationSchema = yup.object({
  title: yup.string().required("Title is required"),
  medicine_type: yup.string().required("Medicine type is required"),
  medication_type: yup.string().required("Form is required"),
  frequency: yup.string().required("Frequency is required"),
  start_date: yup.string().required("Start date is required"),
  route_administration: yup.string().required("Route is required"),

  weekdays: yup.array().when("frequency", {
    is: (val) => val?.toLowerCase() === "weekly",
    then: () => yup.array().min(1, "Select at least one day").required("Required"),
    otherwise: () => yup.array().notRequired(),
  }),

  individual_meds: yup.array().when("medicine_type", {
    is: "Individual Medication",
    then: () => yup.array().of(
      yup.object().shape({
        name: yup.string().required("Required"),
        dose: yup.string().required("Required"),
        initial_stock_qty: yup.number()
          .transform((value) => (isNaN(value) ? undefined : value))
          .typeError("Must be a number")
          .required("Required"),
      })
    ).min(1, "Add at least one medicine"),
  }),

  medicine_list: yup.array().when("medicine_type", {
    is: "Blister Pack",
    then: () => yup.array().min(1, "Select at least one medicine"),
  }),
  
  total_slots_remaining: yup.number().when("medicine_type", {
    is: "Blister Pack",
    then: () => yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .typeError("Must be a number")
      .required("Required"),
    otherwise: () => yup.number()
      .transform((value) => (value === "" || isNaN(value) ? undefined : value))
      .nullable()
      .notRequired(),
  }),

  times: yup.array().of(
    yup.object().shape({
      time: yup.string().required("Required").nullable(),
      careplan: yup.mixed().required("Required"),
    })
  ).min(1, "At least one time is required"),
});